import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { get as _get } from 'lodash';

import { clearSnackbar } from '../actions/environment';

import Snackbar from '../components/Common/Snackbar';

class SnackbarContainer extends Component {
    render() {
        return (
            <Snackbar { ...this.props } />
        );
    }
}

function mapStateToProps(state) {
    const { snackbar } = state.environment;

    return {
        message: _get(snackbar, `message`),
        callback: _get(snackbar, `callback`),
        actionText: _get(snackbar, `actionText`),
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        onHide: clearSnackbar
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SnackbarContainer);



// WEBPACK FOOTER //
// ./scripts/containers/SnackbarContainer.jsx